import React, { createElement, useState } from 'react';
import moduleCss from './index.module.scss';
import 'swiper/swiper.min.css';
import 'swiper/components/navigation/navigation.min.css';
import { Swiper } from 'swiper/esm/react/swiper.js';
import { SwiperSlide } from 'swiper/esm/react/swiper-slide.js';
import SwiperCore, { Navigation } from 'swiper';
import { Mask } from '@ifeng/lowcode_tool/src/components/Mask'
import { useChip, TYPE_Chip } from '@ifeng/lowcode_tool/src/hooks/useChip'
import { formatChip } from '@ifeng/lowcode_tool/src/method/chip'
import { getThumbnailFromRecommend } from '@ifeng/lowcode_tool/src/method/common'
import { formatImage } from '@ifeng/public_method'
import Chip from 'Chip';

SwiperCore.use([Navigation]);

export interface NewsList_5_Props {
    nodeId?: string;
    style?: object;
    newsChip: TYPE_Chip;
}

const NewsList_5: React.FC<NewsList_5_Props> = (props) => {
    const { nodeId, newsChip, style } = props;

    const [currentIndex, setCurrentIndex] = useState(0);

    const newsChipData = useChip(newsChip);
    const chipComponentData = formatChip(newsChip)

    const handlePrev = () => {
        const res = currentIndex - 1;

        if (res < 0) {
            return;
        }

        setCurrentIndex(res);
    };

    const handleNext = () => {
        const res = currentIndex + 1;

        if (res >= newsChipData.length) {
            return;
        }

        setCurrentIndex(res);
    };

    return (
        <Chip {...chipComponentData}>
            <div id={nodeId} className={moduleCss.NewsList_5} style={style}>
                <div className={moduleCss.swiperWp}>
                    <Swiper
                        slidesPerView={3}
                        navigation={{
                            prevEl: `.${moduleCss.prev}`,
                            nextEl: `.${moduleCss.next}`,
                        }}
                        style={{ width: '100%' }}
                    >
                        {newsChipData.map((item, index) => {
                            return (
                                <SwiperSlide key={index}>
                                    <div
                                        className={`${moduleCss.swiperItem} ${
                                            currentIndex === index ? moduleCss.active : ''
                                        }`}
                                        onClick={() => setCurrentIndex(index)}
                                    >
                                        <div className={moduleCss.title}>{item.source}</div>
                                    </div>
                                </SwiperSlide>
                            );
                        })}
                    </Swiper>
                    <img
                        className={moduleCss.prev}
                        src="https://y0.ifengimg.com/314bd925cdd17196/2014/0228/btn05_l.gif"
                        alt=""
                        onClick={handlePrev}
                    />
                    <img
                        className={moduleCss.next}
                        src="https://y0.ifengimg.com/314bd925cdd17196/2014/0228/btn05_r.gif"
                        alt=""
                        onClick={handleNext}
                    />
                    <div className={moduleCss.articles}>
                        <div className={moduleCss.imagePart}>
                            <a href={newsChipData[currentIndex]?.url} target="_blank">
                                <img
                                    src={formatImage(getThumbnailFromRecommend(newsChipData[currentIndex] || { thumbnails: '' }), 387, 343)}
                                    alt=""
                                />
                                <div className={moduleCss.alt}>{newsChipData[currentIndex]?.title}</div>
                            </a>
                        </div>
                        <div className={moduleCss.articlePart}>
                            {newsChipData[currentIndex]?.children &&
                                newsChipData[currentIndex]?.children.map((article, index) => {
                                    return (
                                        <div className={moduleCss.article} key={index}>
                                            <h5>
                                                <a href={article.url} target="_blank" rel="noreferrer">
                                                    {article.title}
                                                </a>
                                            </h5>
                                            <p>
                                                {article.summary}
                                                <span className={moduleCss.cRed}>
                                                <a
                                                    href={article.url}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    [详细]
                                                </a>
                                            </span>
                                            </p>
                                        </div>
                                    );
                                })}
                        </div>
                    </div>
                </div>
                <Mask visible={!newsChip.id} zIndex={3}>
                    示例推荐位碎片—{newsChip.default.id}
                </Mask>
            </div>
        </Chip>
    );
};

export default NewsList_5;
